import { durationObject } from "../times";

/**
 * Add a class based on the difference in milliseconds between start and end times
 * */
export const durationFilter = (duration: any) => {
  if (duration % 10 === 0) {
    const key = duration as keyof typeof durationObject;
    return durationObject[key];
  }

  return null;
}

/**
 * @param date The current date and time
 *
 * This function is built around the array for the time bar.
 * It has 48 entries at half-hour increments. 00:00, 00:30 and so on.
 * Getting the correct index is for highlighting the time, scrolling the grid, etc.
 *
 * So, to provide the correct array index:
 * - Each hour is doubled
 * - If the minutes are between 30 and 45, add 1 to the index
 * - If the minutes are greater than 45, add 1 to the index
 * */

export const getCurrentTimeIndex = (date: Date) => {
  const hours = date.getHours();
  const minutes = date.getUTCMinutes();
  const currentIndex = hours * 2;

  if (minutes >= 15 && minutes < 30) {
    return currentIndex;
  }

  if (minutes >= 30 && minutes < 45) {
    return (currentIndex + 1);
  }
  if (minutes >= 45) {
    return (currentIndex + 1);
  }

  return currentIndex;
}

// Create a list of date objects from today for the next 2 weeks
export const createDateRange = () => {
  const dates = [];

  // Use the date object to get an accurate array of dates for the next 2 weeks

  const date = new Date();
  date.setHours(0);
  date.setMinutes(0);
  date.setSeconds(0);
  date.setMilliseconds(0);

  for (let i = 0; i < 14; i++) {
    dates.push(new Date(date));
    date.setDate(date.getDate() + 1);
  }

  return dates;
}

/**
 *  Update the time shade, time bar/time shade scroll, current and previous programme highlights every minute.
 * Synced to fire every minute change
 *  */

export const intervalTimeUpdate = (tick: any, clear = false) => {
  let timeout: any;

  return ((...args) => {
    // This is to align the time shade to the device clock (60s - offset until offset = 0).
    const seconds = new Date().getSeconds();
    const timeOutSeconds = 60000 - seconds * 1000;

    if (clear) {
      clearTimeout(timeout);
      return;
    }

    const later = () => {
      if (tick) {
        tick();
      }

      clearTimeout(timeout);
      intervalTimeUpdate(tick, clear);
    };

    clearTimeout(timeout);
    timeout = setTimeout(later, timeOutSeconds);
  })();
}

export const getCurrentLocalizedTimeString = () => {
  /**
   * Borrowed from https://stackoverflow.com/questions/10830357/javascript-toisostring-ignores-timezone-offset/37661393
   * To correct for timezone bugs
   */

  const date = new Date();

  return new Date(
    date.getTime() - date.getTimezoneOffset() * 60000
  ).toISOString();
}

export const createTimeArr = (times: any) => {
  let tempTimeArr: any = [];

  for (let i = 0; i < 14; i++) {
    tempTimeArr = tempTimeArr.concat(times);
  }

  return tempTimeArr;
}